// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HrX5","top":"styles_top__1AgON","left":"styles_left__2h4X4","description":"styles_description__oQVPa"};